import axios from 'axios'
import api_requests from "../api/api_requests";

export default {
    state: {
        status: '',
        token: localStorage.getItem('token') || false,
        user: JSON.parse(localStorage.getItem('user')) || {},
        FB: false,
        byFB: false,
        isConnected: false,
        errors: {message: null}
    },
    getters: {
        getConnected: state => state.isConnected,
        getFB: state => state.FB,
        isLogByFB: state => state.byFB,
        isLoggedIn: state => state.token,
        isActive: state => state.user.email_verified_at ?? false,
        // isAdmin: state => state.user.is_admin ?? false,
        isFacebookUser: state => state.user.facebook_id ?? false,
        userInfo: state => state.user,
        authStatus: state => state.status,
        authErrors: state => state.errors
    },
    mutations: {
        auth_errors(state, data) {
            state.errors = data
        },
        reset_errors(state) {
            state.errors = {message: null}
        },
        user_info(state, user) {
            state.user = user
        },
        auth_success(state, token, user) {
            state.status = 'success'
            state.token = token
            // state.user = user
        },
        auth_request(state) {
            state.status = 'loading'
        },
        auth_error(state) {
            state.status = 'error'
        },
        activate(state, date) {
            state.user.email_verified_at = date
        },
        logout(state) {
            state.byFB = false
            state.status = ''
            state.token = ''
            state.user = {}
            let visitor = ''
            if (localStorage.getItem('visitor')) {
                visitor = localStorage.getItem('visitor')
            }
            let cookieShow = localStorage.getItem('cookieShow')
            localStorage.clear()
            localStorage.setItem('cookieShow', cookieShow)
            localStorage.setItem('visitor', visitor)
        },
        fbLogin(state, user) {
            state.byFB = true
            state.user = user
        },

        updateFB(state, payload) {
            state.FB = payload
        },
        updateConnect(state, payload) {
            state.isConnected = payload
        },
        deleteCookie(name) {
            document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        }
    },
    actions: {
        sdk({commit}, payload) {
            commit('updateFB', payload.FB)
            commit('updateConnect', payload.isConnected)
        },
        loginFB({commit, state}) {
            return new Promise((resolve, reject) => {
                state.FB.api('/me', 'GET', {fields: 'id,name,first_name, last_name,email'},
                    async userInformation => {
                        if (!userInformation.error) {
                            const personalID = userInformation.id;
                            const email = userInformation.email;
                            const name = userInformation.name;
                            const first_name = userInformation.first_name;
                            const last_name = userInformation.last_name;
                            const avatar = `https://graph.facebook.com/${personalID}/picture?type=large&width=720&height=720`
                            const user = {
                                facebook_id: personalID,
                                email,
                                name,
                                first_name,
                                last_name,
                                avatar
                            }
                            await axios.post(process.env.VUE_APP_API + '/soc', user)
                                .then(resp => {
                                    if (resp.status === 200) {
                                        if (resp.data.access_token !== undefined && resp.data.token_type !== undefined) {
                                            const onlyToken = resp.data.access_token
                                            const tokenType = resp.data.token_type
                                            const token = `${tokenType} ${onlyToken}`
                                            localStorage.setItem('token', token)
                                            commit('auth_success', token)
                                            axios.post(process.env.VUE_APP_API + '/details', null, {
                                                headers: {
                                                    'Authorization': localStorage.getItem('token')
                                                }
                                            }).then((resp) => {
                                                    commit('user_info', resp.data)
                                                    commit('fbLogin', user)
                                                    localStorage.setItem('user', JSON.stringify(resp.data))
                                                let userDashboard = {
                                                    email: String(JSON.parse(localStorage.user).email),
                                                    full_name: String(JSON.parse(localStorage.user).name),
                                                    first_name: "",
                                                    last_name: "",
                                                    client_id: String(JSON.parse(localStorage.user).id),
                                                    event_time: "2020-05-03T08:41:22.401Z",
                                                    email_verified_at: "2020-05-03T08:41:22.401Z",
                                                    phone: "+1123",
                                                    country: "US",
                                                    pay_country: "US",
                                                    ip: "127.0.0.1",
                                                    deleted_at: null,
                                                    data: {}
                                                }
                                                axios.post(process.env.VUE_APP_API + '/dashboard-integration/clients/create', userDashboard,
                                                    {
                                                        headers: {
                                                            'Authorization':
                                                            localStorage.getItem('token')
                                                        }
                                                    }
                                                )
                                                    .then((resp) => {
                                                        const data = {
                                                            client_id: String(JSON.parse(localStorage.user).id),
                                                            payment_system_name: "None",
                                                            currency_code: "USD",
                                                            return_url: "https://yandex.ru",
                                                            cancel_url: "https://google.com",
                                                            plan_id: 13,
                                                            payment_system_account_id: 1
                                                        }
                                                        axios
                                                            .post(process.env.VUE_APP_API + '/dashboard-integration/payments/create', data, {
                                                                headers: {
                                                                    'Authorization': localStorage.getItem('token')
                                                                }
                                                            })
                                                            .then((resp) => {
                                                                console.log(resp)
                                                            })
                                                            .catch(err => {
                                                                console.log(err)
                                                            })
                                                        console.log(resp)
                                                    })
                                                    .catch((err) => {
                                                        console.log(err)
                                                    })
                                                    resolve(resp)
                                                }
                                            )
                                        } else {
                                            localStorage.removeItem('token')
                                            resolve(false)
                                        }
                                    }
                                })
                                .catch(err => {
                                    console.log(err)
                                    commit('auth_error')
                                    localStorage.removeItem('token')
                                    reject(err)
                                })
                        }

                    }
                )
            })
        },
        logoutFB({commit, state}) {
            state.FB.logout((response) => {
                commit('deleteCookie', "fblo_" + 350674055895004);
            });
            commit('logout')
        },
        login_v2({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                api_requests.login_app(user)
                    .then((resp) => {
                        const onlyToken = resp.data.access_token
                        const tokenType = resp.data.token_type
                        const token = `${tokenType} ${onlyToken}`
                        localStorage.setItem('token', token)
                        commit('auth_success', token)

                        api_requests.get_details_user_app(null)
                            .then((resp) => {
                                commit('user_info', resp.data)
                                localStorage.setItem('user', JSON.stringify(resp.data))
                                resolve(resp)

                            })
                            .catch(error => {
                                commit('auth_error')
                                localStorage.removeItem('token')
                                reject(error)
                            })
                    })
                    .catch(error => {
                        commit('auth_error')
                        console.log('login______')
                        console.log(error.response)
                        let message = ''
                        for (let key in error.response.data.message) {
                            message += error.response.data.message[key]
                        }
                        commit('auth_errors', {message: message})
                        localStorage.removeItem('token')
                        reject(error)
                    })
            })
        },
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post(process.env.VUE_APP_API + '/login', user, { validateStatus: () => true })
                    .then(resp => {
                        if (resp.status !== 200) {
                            commit('auth_error')
                            console.log(error.response)
                            // let message = ''
                            // for (let key in error.response.data.message) {
                            //     message += error.response.data.message[key]
                            // }
                            // commit('auth_errors', {message: message})
                            resolve(resp)
                        } else {
                            const onlyToken = resp.data.access_token
                            const tokenType = resp.data.token_type
                            const token = `${tokenType} ${onlyToken}`
                            localStorage.setItem('token', token)
                            commit('auth_success', token)
                            axios
                                .post(process.env.VUE_APP_API + '/details', null, {
                                    headers: {
                                        'Authorization': localStorage.getItem('token')
                                    }
                                })
                                .then((resp) => {
                                    commit('user_info', resp.data)
                                    commit('activate', resp.data.email_verified_at)
                                    localStorage.setItem('user', JSON.stringify(resp.data))
                                    resolve(resp)

                                })
                                .catch(err => {
                                    commit('auth_error')
                                    localStorage.removeItem('token')
                                    reject(err)
                                })
                        }
                    })
                    .catch(error => {
                        commit('auth_error')
                        let message = ''
                        for (let key in error.response.data.message) {
                            message += error.response.data.message[key]
                        }
                        commit('auth_errors', {message: message})
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        registration_v2({dispatch, commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                api_requests.registration_app(user)
                    .then((resp) => {
                        const onlyToken = resp.data.access_token
                        const tokenType = resp.data.token_type
                        const token = `${tokenType} ${onlyToken}`
                        if (resp.status === 200) {
                            localStorage.setItem('token', token)
                            commit('auth_success', token)
                        }
                        api_requests.get_details_user_app(null)
                            .then((resp) => {
                                commit('user_info', resp.data)
                                localStorage.setItem('user', JSON.stringify(resp.data))
                                //dispatch('create_user_dashboard')
                            })
                            .catch((error) => {
                                console.log(error)
                            })
                        resolve(resp)
                    })
                    .catch(error => {
                        //commit('auth_error')
                        let message = ''
                        for (let key in error.response.data.errors) {
                            message += error.response.data.errors[key] + ' '
                        }
                        commit('auth_errors', {message: message})
                        localStorage.removeItem('token')
                        reject(error)
                    })
            })
        },
        registration({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post(process.env.VUE_APP_API + '/register', user, { validateStatus: () => true })
                    .then(resp => {
                        const onlyToken = resp.data.access_token
                        const tokenType = resp.data.token_type
                        const token = `${tokenType} ${onlyToken}`
                        if (resp.status === 200) {
                            localStorage.setItem('token', token)
                            commit('auth_success', token)
                        }
                        axios.post(process.env.VUE_APP_API + '/details', null, {headers: {'Authorization': localStorage.getItem('token')}})
                            .then((resp) => {
                                commit('user_info', resp.data)
                                localStorage.setItem('user', JSON.stringify(resp.data))
                                let userDashboard = {
                                    email: String(JSON.parse(localStorage.user).email),
                                    full_name: String(JSON.parse(localStorage.user).name),
                                    first_name: "",
                                    last_name: "",
                                    client_id: String(JSON.parse(localStorage.user).id),
                                    event_time: "2020-05-03T08:41:22.401Z",
                                    email_verified_at: "2020-05-03T08:41:22.401Z",
                                    phone: "+1123",
                                    country: "US",
                                    pay_country: "US",
                                    ip: "127.0.0.1",
                                    deleted_at: null,
                                    data: {}
                                }
                                axios.post(process.env.VUE_APP_API + '/dashboard-integration/clients/create', userDashboard,
                                    {
                                        headers: {
                                            'Authorization': localStorage.getItem('token')
                                        }
                                    })
                                    .then((resp) => {
                                        const data = {
                                            client_id: String(JSON.parse(localStorage.user).id),
                                            payment_system_name: "None",
                                            currency_code: "USD",
                                            return_url: "https://yandex.ru",
                                            cancel_url: "https://google.com",
                                            plan_id: 3,
                                            payment_system_account_id: 1
                                        }
                                        axios
                                            .post(process.env.VUE_APP_API + '/dashboard-integration/payments/create', data, {
                                                headers: {
                                                    'Authorization': localStorage.getItem('token')
                                                }
                                            })
                                            .then((resp) => {
                                                console.log(resp)
                                            })
                                            .catch(err => {
                                                console.log(err)
                                            })
                                    })
                                    .catch((err) => {
                                        console.log(err)
                                    })
                                resolve(resp)


                            })
                            .catch(err => {
                                console.log(err)
                                commit('auth_error')
                                localStorage.removeItem('token')
                                reject(err)
                        })

                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err)
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                api_requests.logout_app()
                    .then(() => {
                        commit('logout')
                        localStorage.removeItem('token')
                        resolve()
                    })
                    .catch(() => {
                        commit('logout')
                        localStorage.removeItem('token')
                        reject()
                    }
                )
            })
        },
        details({commit}) {
            return new Promise((resolve, reject) => {
                api_requests.get_details_user_app(null)
                    .then((resp) => {
                        commit('user_info', resp.data)
                        localStorage.setItem('user', JSON.stringify(resp.data))
                        resolve(resp)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
        update_details_state({commit}, data) {
            commit('user_info', data)
        },
        resetPassword({commit}, data) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + `/reset/${data.token}`, {password: data.password}, {})
                    .then((res) => {
                            resolve(res)
                        }
                    )
            })
        },
        async changePassword({commit}, data) {
            return await axios.post(process.env.VUE_APP_API + `/change-password`, {
                password: data.password,
                new_password: data.new_password
            }, {
                headers: {
                    'Authorization': localStorage.getItem('token')
                }
            })
                .then((res) => {
                        return res.data
                    }
                )

        },
        checkActiviti({commit}) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/check-confirm-email`, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                    .then((res) => {
                            if (res.status === 200) {
                                commit('user_info', res.data)
                                localStorage.setItem('user', JSON.stringify(res.data))
                                // commit('activate', res.data.email_verified_at)
                                // if (res.data.email_verified_at) {
                                //     resolve(true)
                                // }
                                resolve(true)
                            } else {
                                resolve(false)
                            }
                        }
                    )
            })
        },
        resetPasswordSetClient({commit}, email) {
            return new Promise(((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + '/reset', {email}, {})
                    .then(res => {
                        resolve(res)
                    })
            }))
        },
        checkToken({commit}, token) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/check-reset/${token}`, {})
                    .then((res) => {
                            // commit('logout')
                            // localStorage.removeItem('token')
                            resolve(res.data)
                        }
                    )
                    .catch((error)=> {
                        console.log(error)
                    })
            })
        },
            changeActivate(ctx, token) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/change-confirm-email/${token}`, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                    .then((res) => {
                        ctx.commit('activate', res.data.email_verified_at)
                        resolve(res)
                        // localStorage.removeItem('token')
                    })
                    .catch((err)=>{
                        if (err.response.status === 401) {
                            resolve(err.response);
                        } else {
                            reject(err)
                        }
                    })
            })
        },
        confirmRequestToChangeEmail({ctx}, token) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/confirm-request-to-change-email/${token}`, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                    .then((res) => {
                            // localStorage.removeItem('token')
                            resolve(res)
                        }
                    ).catch(res => {
                    if (res.response.status) {
                        resolve({status: res.response.status});
                    }
                })
            })
        },
        proved({ctx}, token) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/proved/${token}`)
                    .then((res) => {
                            // localStorage.removeItem('token')
                            resolve(res)
                        }
                    )
            })
        },
        sendEmailToActivate({ctx}, result) {
            return new Promise((resolve, reject) => {
                axios.get(process.env.VUE_APP_API + `/send-email-to-activate`, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                    .then((res) => {
                            resolve(res)
                            result = Boolean(res)
                        }
                    )
                    .catch((err) => {
                        console.log(err)
                        result = !Boolean(res)
                    })

            })
        },
        create_user_dashboard() {
            let userDashboard = {
                email: String(JSON.parse(localStorage.user).email),
                full_name: String(JSON.parse(localStorage.user).name),
                first_name: String(JSON.parse(localStorage.user).first_name),
                last_name: String(JSON.parse(localStorage.user).last_name),
                client_id: String(JSON.parse(localStorage.user).id),
                event_time: "",
                email_verified_at: "",
                phone: "",
                country: "",
                pay_country: "",
                ip: "",
                deleted_at: null,
                data: {}
            }
            api_requests.create_user_on_dashboard(userDashboard)
                .then((resp) => {
                    console.log(resp)
                })
        },
        create_free_subscription() {
            api_requests.create_free_subscription()
                .then((resp) => {

                })
                .catch((error) =>{

                })
            axios
                .post(process.env.VUE_APP_API + '/dashboard-integration/payments/create', data, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then((resp) => {
                    console.log(resp)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        resetError(ctx) {
            ctx.commit('reset_errors')
        }
    }
}
